<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

  <ng-container *ngIf="consulta">

    <div class="body">

      <ng-container *ngFor="let r of consulta?.registros; let i = index">
        <h2 class="subtitle subtitle-{{status}}">PROTESTO {{i+1}}</h2>
        <ul class="card-list-striped py-1">
          <li>
            <span class="text-secondary">CARTÓRIO:</span>
            <span class="text-uppercase">{{ r?.cartorio || r?.cartorio_protest_est || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">DATA:</span>
            <span class="text-uppercase">{{ r?.data || r?.data_protest_est || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">NATUREZA:</span>
            <span class="text-uppercase">{{ r?.natureza || r?.natureza_protest_est || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">CIDADE:</span>
            <span class="text-uppercase">{{ r?.cidade || r?.cidade_protest_est || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">UF:</span>
            <span class="text-uppercase">{{ r?.uf || r?.uf_protest_est || msgNull }}</span>
          </li>
          <li>
            <span class="text-secondary">VALOR:</span>
            <span class="text-uppercase">{{ r?.valor || r?.valor_protest_est || msgNull }}</span>
          </li>
        </ul>
      </ng-container>

    </div>

  </ng-container>

</app-card-consulta>